import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { EditableReusableCustomQuestionGroup } from "../../shared/interfaces/ReusableCustomQuestionGroup";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useCustomQuestionGroupUpdate(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["customQuestionGroupUpdate"],
    async (customQuestionGroup: EditableReusableCustomQuestionGroup) =>
      apiContext.customWorkflowQuestionApis.updateCustomQuestionGroup(customQuestionGroup),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
